
import { useCreateDraftEvent } from "./use-create-draft-event";
import { useAddGuests } from "./use-add-guests";
import { useEnsureAuthenticatedUser } from "./use-ensure-authenticated-user";

export const useEventMutations = (onSuccess: (eventId: string) => void) => {
  const ensureAuthenticatedUser = useEnsureAuthenticatedUser();
  const createDraftEvent = useCreateDraftEvent(onSuccess, ensureAuthenticatedUser);
  const addGuestsMutation = useAddGuests(ensureAuthenticatedUser);

  return {
    createDraftEvent,
    addGuestsMutation
  };
};

